import BaseClient, { Response, StatusResponse } from './Client';
import sanitizeParams from './utils/params';
import { PageItemAttributes } from './PageItemClient';

interface PageBody {
  title: string | null;
  description: string | null;
  rank: number;
  show: boolean;
}

export interface PageResponse extends PageBody {
  id: string;
  type: string;
  routeName: string;
  pageItems: PageItemAttributes[];
}

interface Client {
  list: () => Response<PageResponse[]>;
  get: (pageId: string) => Response<PageResponse>;
  create: (data: PageBody) => Response<PageResponse>;
  update: (pageId: string, data: PageBody) => Response<PageResponse>;
  delete: (pageId: string) => Response<StatusResponse>;
}

export class PageClient extends BaseClient implements Client {
  private getPageUrl = (pageId?: string): string => {
    const pagePath = pageId ? `pages/${pageId}` : 'pages';

    return `${this.getWwsHost()}/gs/api/${pagePath}`;
  };

  /*
   * Page Methods
   */

  public list = (): Response<PageResponse[]> => {
    return this.callWwsApi(this.getPageUrl(), {
      method: 'GET',
    });
  };

  public get = (pageId: string): Response<PageResponse> => {
    return this.callWwsApi(this.getPageUrl(pageId), {
      method: 'GET',
    });
  };

  public create = (data: PageBody): Response<PageResponse> => {
    return this.callWwsApi(this.getPageUrl(), {
      method: 'POST',
      data: sanitizeParams(data),
    });
  };

  public update = (pageId: string, data: PageBody): Response<PageResponse> => {
    return this.callWwsApi(this.getPageUrl(pageId), {
      method: 'PUT',
      data: sanitizeParams(data),
    });
  };

  public delete = (pageId: string): Response<StatusResponse> => {
    return this.callWwsApi(this.getPageUrl(pageId), {
      method: 'DELETE',
    });
  };
}
